import axios from '@axios'
import config from '@core/app-config/api-config'

/** Results normalization (docs/results-analytics): distance names the statistics could not read, and their aliases */
const resultsAdmin = `${config.host}/results/admin`

const resultsApi = {
  getUnknownDistances(params) {
    return axios.get(`${resultsAdmin}/unknown-distances`, { params })
  },
  getAliases() {
    return axios.get(`${resultsAdmin}/aliases`)
  },
  saveAlias(payload) {
    return axios.put(`${resultsAdmin}/aliases`, payload)
  },
  removeAlias(id) {
    return axios.delete(`${resultsAdmin}/aliases/${id}`)
  },
  rebuildStart(startId) {
    return axios.post(`${resultsAdmin}/rebuild/${startId}`)
  },
}

export default resultsApi
